import {
  LIST_CLASSIFICACAO_INIT,
  LIST_CLASSIFICACAO_SUCCESS,
  CREATE_CLASSIFICACAO_INIT,
  CREATE_CLASSIFICACAO_SUCCESS,
  UPDATE_CLASSIFICACAO_INIT,
  UPDATE_CLASSIFICACAO_SUCCESS,
  DELETE_CLASSIFICACAO_INIT,
  DELETE_CLASSIFICACAO_SUCCESS,
  CLASSIFICACAO_ERROR_MSG,
  CLEAR_CLASSIFICACAO
} from '../actionTypes';

const INIT_STATE: any = {
  loading: false,
  isCreated: false,
  isUpdated: false,
  isDeleted: false,
  isError: false,
  classificacoes: [],
  msg: ''
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_CLASSIFICACAO_INIT:
      return { ...state, loading: true };
    case LIST_CLASSIFICACAO_SUCCESS: {
      const { classificacoes } = action.payload;
      
      return {
        ...state,
        classificacoes,
        loading: false
      };
    }
    case CREATE_CLASSIFICACAO_INIT:
      return {
        ...state,
        isCreated: false
      };
    case CREATE_CLASSIFICACAO_SUCCESS: {
      const { msg, isCreated, classificacao} = action.payload;
      return {
        ...state,
        classificacoes: state.classificacoes.concat(classificacao),
        msg,
        isCreated
      };
    }
    case UPDATE_CLASSIFICACAO_INIT:
      return {
        ...state,
        isUpdated: false
      };
    case UPDATE_CLASSIFICACAO_SUCCESS: {
      const { msg, isUpdated, classificacao } = action.payload;
      return {
        ...state,
        classificacoes: state.classificacoes.map((m: any) => m.id === classificacao.id ? classificacao : m),
        msg,
        isUpdated
      };
    }
    case DELETE_CLASSIFICACAO_INIT:
      return {
        ...state,
        isDeleted: false
      };
    case DELETE_CLASSIFICACAO_SUCCESS: {
      const { msg, isDeleted, classificacao } = action.payload;
      return {
        ...state,
        classificacoes: state.classificacoes.filter((m: any) => m.id !== classificacao.id),
        msg,
        isDeleted
      };
    }
    case CLASSIFICACAO_ERROR_MSG: {
      const { msg } = action.payload;
      return { ...state, loading: false, isError: true, msg };
    }
    case CLEAR_CLASSIFICACAO: {
      return {
        ...state,
        isUpdated: false,
        isCreated: false,
        isDeleted: false,
        isError: false,
        loading: false,
        msg: ''
      };
    }
    default:
      return { ...state };
  }
};
